import React from "react"

import { css } from "@emotion/react"

import type { IScreenTab } from "@front-shared/types/objects.types.ts"

import { NIRVANA_COLORS } from "../config/theme.config.ts"
import { PrimaryText } from "./primaryText.element"

export const ScreenTabsElement: React.FunctionComponent<
    IScreenTabsElementProps
> = props => {
    const isTabActive = (tab: IScreenTab): boolean =>
        tab.key === props.currentTab.key

    return (
        <div
            className={`
                flex items-end
                ${props.className}
            `}
        >
            {props.tabs.map((item: IScreenTab, index: number) => (
                <div
                    key={index}
                    css={[
                        styles.tabWrapper,

                        !isTabActive(item)
                            ? css({
                                  cursor: "pointer",
                              })
                            : undefined,
                    ]}
                    onClick={props.onSelected.bind({}, item)}
                >
                    <PrimaryText
                        typography={isTabActive(item) ? "textSemibold" : "text"}
                        centered={!props.renderAdditionalTabContent}
                    >
                        {item.label}
                    </PrimaryText>

                    {props.renderAdditionalTabContent?.(item)}

                    <div
                        css={[
                            styles.tabUnderline,

                            isTabActive(item)
                                ? styles.activeTabUnderlineActive
                                : styles.activeTabUnderlineInactive,
                        ]}
                    />
                </div>
            ))}
        </div>
    )
}

const styles = {
    tabWrapper: css({
        flex: 1,
        position: "relative",
        padding: 8,
    }),
    tabUnderline: css({
        backgroundColor: NIRVANA_COLORS.brand.primary,
        position: "absolute",
        zIndex: 10,
        left: 0,
        bottom: 0,
        width: "100%",
    }),
    activeTabUnderlineActive: css({
        height: 3,
    }),
    activeTabUnderlineInactive: css({
        height: 1,
    }),
}

interface IScreenTabsElementProps {
    className?: string
    tabs: IScreenTab[]
    currentTab: IScreenTab
    onSelected: (tab: IScreenTab) => void
    renderAdditionalTabContent?: (tab: IScreenTab) => React.JSX.Element | null
}
